import { createAsyncThunk } from '@reduxjs/toolkit';
import axios  from 'config/axios';
import { setCloudTypes, setErrors,setThreat,setTopAlerts} from  'stores/modules/vapt/alertreducer'

export const deleteAlerts= async (params) => {
    try {
       await axios.delete(`${process.env.REACT_APP_VAPT_ALERTS_ENDPOINT_URL}/alerts`,{
        params:params,
      });
      return true;
 
    } catch (error) {
      return error?.response?.data?.message;
    }
  };

  export const fetchAlertById= createAsyncThunk('alert/fetchAlertById', async ({ idToken,id }, { dispatch }) => {
    try {   
      dispatch(setErrors([]))
      let response = await axios.get(`${process.env.REACT_APP_VAPT_ALERT_ENDPOINT_URL}/alert/${id}`, {
      });
      dispatch(setThreat(response.data));
    } catch (error) {
      dispatch(setErrors(error.response));
    }
  });

  export const fetchAlertsList = async ({ params}) => {
    try {
      const updatedParams = { ...params, page: params.page, limit: params.limit };
  
      
      if (params.search) {
        updatedParams.search = params.search;
      }
      let response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/submited-alerts-list`, {
        params: updatedParams,
      });
  
      return response;
    } catch (error) {
      return error?.response?.data?.message;
    }
  };

  export const fetchAlerts = async ({ params}) => {
    try {
      const updatedParams = { ...params, page: params.page, limit: params.limit };
  
      
      if (params.search) {
        updatedParams.search = params.search;
      }
      let response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/alerts-list`, {
        params: updatedParams,
      });
  
      return response;
    } catch (error) {
      return error?.response?.data?.message;
    }
  };

  export const fetchTopAlerts = createAsyncThunk('alert/fetchTopAlerts', async ({ idToken, params }, { dispatch }) => {
    try {
      dispatch(setTopAlerts([]));
      setErrors([]);
      let response;
      if (params.compliance){
        delete params.compliance;
        response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/compliance/top-alerts`,  {
          params: params,
        });
      }
      else{
        response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/top-alerts`, {
          params: params,
        });
      }
      if (response.status === 200){
        dispatch(setTopAlerts(response.data));
      }
      else{
        dispatch(setErrors(response.data));
      }
    } catch (error) {
      dispatch(setErrors(error.response));
    }
  });

  export const fetchCloudTypes= createAsyncThunk('company/fetchApplications',async (idToken, { dispatch }) => {
    try {    
      const response = await axios.get(`${process.env.REACT_APP_IDP_APPLICATION_ENDPOINT_URL}/cloudtypes`,{
      });
      dispatch(setCloudTypes(response.data))
    } catch (error) {
      dispatch(setErrors(error.response));
     
    }
  }
  );


  export const fetchTopAlertsById = createAsyncThunk('alert/fetchTopAlertsById', async ({ idToken, params }, { dispatch }) => {
    try {
      dispatch(setTopAlerts([]));
      setErrors([]);
      const response=await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/top-alertsByCompany`, {
              params: params,
            });;
      
      
      if (response.status === 200){
        dispatch(setTopAlerts(response.data));
      }
      else{
        dispatch(setErrors(response.data));
      }
    } catch (error) {
      dispatch(setErrors(error.response));
    }
  });